import { verifyCredential } from '@trustvc/w3c-vc';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const verifyW3CSignature = /* @__PURE__ */ __name(async (credential, options) => {
  return verifyCredential(credential, options);
}, "verifyW3CSignature");

export { verifyW3CSignature };
